// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createProductFeedProductFeed = (client) => ({
    /**
     * `GET /product-feed`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId ProductFeedProductFeedList
     * @source apps/backend/src/api/product-feed/route.ts
     */
    list: (query, headers) => client.fetch("/product-feed", { method: "GET", query, headers }),
});
//# sourceMappingURL=product-feed.js.map